<template>
  <span :class="styles" v-text="text" />
</template>

<script>
import { AnGoogleStatuses } from '@/models/Creative'

export default {
  name: 'CreativeAnGoogleStatus',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    isRejected() {
      return this.value === AnGoogleStatuses.REJECTED
    },
    text() {
      switch (this.value) {
        case AnGoogleStatuses.NO_AUDIT: {
          return '審査無し'
        }
        case AnGoogleStatuses.PENDING: {
          return '審査中'
        }
        case AnGoogleStatuses.APPROVED: {
          return '承認済み'
        }
        case AnGoogleStatuses.REJECTED: {
          return '却下'
        }
        default: {
          throw new Error(`未対応の審査ステータスです：${this.value}`)
        }
      }
    },
    styles() {
      return {
        'red--text': this.isRejected,
      }
    },
  },
}
</script>

<style></style>
